export class ProductCard {
    constructor(productCode: string, imageUrl: string, release: string = '', date: string = '', cardLinks: CardLink[] = [], productDirectDownload: ProductDirectDownload = null) {        
        this.ProductCode = productCode;
        this.ImageUrl = imageUrl;
        this.CardLinks = cardLinks;
        this.Release = release;
        this.Date = date;
        this.ProductDirectDownload = productDirectDownload;
    }

    ProductCode: string;
    ImageUrl: string;
    CardLinks: CardLink[] = [];
    Release: string;
    Date: string;
    ProductDirectDownload: ProductDirectDownload;
}

export class CardLink {
    constructor(text: string, url: string, params?: object){
        this.Text = text;
        this.Url = url;
        this.Params = params ?? {};
    }

    Text: string;
    Url: string;
    Params: object = {};
}

export class ProductDirectDownload {
    constructor(show: boolean, url: string){
        this.Show = show;
        this.Url = url;
    }
    
    Show: boolean = true;
    Url: string;
}